<template>
  <div class="links">
    <div class="row">
      <div class="col-md-12">
        <loading v-if="! showContent"></loading>
        <h2 class="titulo" v-if="showContent">{{ title }}</h2>
        <div class="links" v-if="showContent">
          <ul>
            <li v-for="item in items">
              <strong>
                <a :href="item.link" target="_blank">
                  {{ item.name }}
                </a>
              </strong>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
  import {get} from '../../helpers/api';
  import Loading from '../common/Loading.vue';

  export default {
    components: {
      Loading
    },
    props: ['bloco'],
    data() {
      return {
        title: 'Links',
        showContent: true,
        items: [],
      }
    },
    created() {
      if (this.bloco.nome) {
        this.title = this.bloco.nome;
      }
      let self = this;
      get('content/' + this.bloco.id).then(function (response) {
        self.showContent = true;
        self.items = response.data.result.data;
        // self.items = window.siteconfig.result.data.links;
      });
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/home/Links.vue